import { render, staticRenderFns } from "./DisplayContactInformation.vue?vue&type=template&id=4993f534&"
import script from "./DisplayContactInformation.vue?vue&type=script&lang=js&"
export * from "./DisplayContactInformation.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports